// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
export { personalize } from './lib/personalization/personalize';
export { PACKAGE_VERSION, PERSONALIZE_NAMESPACE } from './lib/consts';
import './lib/initializer/browser/initializer';
